import { Heading } from 'sierra-ui/primitives'
import styled from 'styled-components'

export const TitleCardHeading = styled(Heading).attrs({ size: 'hSuper' })`
  color: ${p => p.theme.home.textColor};
`
